
<div #contentToConvert id="contentToConvert" class="row  d-flex justify-content-center screenSize"  >
<div class=" row col-md-11 ">
    <div class="col-md-6 d-flex justify-content-start align-items-center">
    <img src="../../../assets/images/world.jpeg"  alt="" width="180px"  height="100px" >
    </div>
    <div class="col-md-6 d-flex justify-content-end align-items-center">
        <img src="../../../assets/images/linux.png" alt="" width="180px" height="170px" > 
    </div>
</div>
    <div class="col-md-11 row  rounded mt-4 pt-2 pb-2 mb-1" style="font-size: 24px; border: 1px solid grey;" >
           <div class="col-md-5 border-right "  >
               <div class="col-md-12 bold d-flex justify-content-center"> Client </div>
                <div class="col-md-12 d-flex justify-content-center" >{{pnrData?.clientName}}</div>

           </div>
           <div class="col-md-6">
               <div class="col-md-12 bold d-flex justify-content-center">OrderId</div>
               <div class="col-md-12 d-flex justify-content-center"> {{pnrData?.orderId}}</div>
            </div>
    </div>
    <div class="col-md-11 row d-flex  justify-content-center  rounded mb-1 pl-0 pr-0" style="font-size: 24px; border: 1px solid grey;">
        <span class="col-md-3 " style="border-right: 1px solid grey;" >
            <div class="col-md-12 d-flex justify-content-center " >{{pnrData?.orderId}}</div>
            <div class="col-12 bold d-flex justify-content-center">CartId</div>
        </span>
        <span class="col-md-3 " style="border-right: 1px solid grey;">
            <div class="ccol-md-12 d-flex justify-content-center ">Business&nbsp;&nbsp;Travel</div>
            <div class=" col-md-12 bold d-flex justify-content-center">Travel&nbsp;&nbsp;Mode</div>

        </span>
        <span class="col-md-3 " style="border-right: 1px solid grey;">
            <div class="col-md-12 bold d-flex text-success justify-content-center"  >{{statuValue(pnrData?.status)}}</div>
            <div class="col-md-12 bold d-flex justify-content-center"  >Status</div>

        </span>
        <div class="col-md-3 " >
            <div class="col-md-12 d-flex justify-content-center" >{{pnrData.creationTime}}</div>
            <div class="col-md-12 d-flex justify-content-center bold">Booked&nbsp;&nbsp;On</div>

        </div>
    </div>
   
    <div class="col-md-11 ml-0 pl-0  row  rounded pt-2 pb-2 mb-1" style="font-size: 24px; border: 1px solid grey;">
        <div class=" mb-4" *ngFor="let itinerary of pnrData.invoiceItineraryList">  
            <div class="container ">
                <div class="ticket-container" >
                        <div class="ticket-header" >  
                            <div class="row col-md-12 row">
                                <div class="d-flex justify-content-start align-items-center col-md-6">
                                    <mat-icon style="font-size: 24px;"> local_airport</mat-icon> <strong style="color: blue; font-size: 30px;">{{itinerary?.fromCity +' to '+itinerary?.toCity}} </strong>
                                    <span style="background-color: brown;color:white; border-radius:2px;padding-right:3px;padding-left:3px ;margin-left: 10px;">{{itinerary?.invoiceFlightDetails[0]?.scheduleDepartureDay}}</span>
                                </div>
                                <div class="d-flex justify-content-end col-md-6">
                                <span class="d-flex align-items-center" style="padding-right: 10px;">Airline&nbsp;&nbsp;PNR  &nbsp; &nbsp; <strong style="color: blue; font-size: 30px;">{{ itinerary?.itineraryPNR}}</strong></span> 
                                </div>
                            </div>
                        </div>
                        <div  *ngFor="let item of itinerary.invoiceFlightDetails">
                        <div class="col-md-12 row"> 
                        <div class="col-md-3 mt-3"> 
                            <div class="col-md-12 ">
                                <div class="col-md-12 d-flex justify-content-start">
                                    <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">

                               
                                <strong style="padding-left: 4px;">{{fligthNameFilter(item?.carrierName)}}</strong>
                                </div>
                                <div class="col-md-12  d-flex justify-content-start " style="padding-left: 28px;"> {{item?.carrierName }} - {{ item?.flightNumber }}</div>
                                <div class="col-md-12  d-flex justify-content-start " style="padding-left: 28px;"> Class - {{ itinerary?.bookingClass }}</div>        
                                <div class="col-md-12  d-flex justify-content-start " style="padding-left: 28px;"> Type - {{ itinerary?.fareType }}</div>        
                            
                        </div>
                        </div>
                        <div class="col-md-9">
                        <div class="trip-details-container">
                            <div class="panel mt-3"  >  
                            <div  class="panel-content">
                                <div class="flights " >
                                </div>
                            </div>
                            <div class="col-md-12 row" style="font-size: 24px;"> 
                                <div class="col-md-5 ">
                                    <div class="col-md-12  d-flex justify-content-start" style="font-size: 20px;">{{item?.scheduleDepartureDay}}</div>
                                    <div class="col-md-12 bold d-flex justify-content-start">{{item?.departureCity}}</div>
                                    <div class="col-md-12 d-flex justify-content-start">{{item?.scheduleDepartureTime }}</div>
                                    <div class="col-md-12 d-flex justify-content-start" style="font-size: 18px;">{{item?.departureAirPort}}</div>
                                    <div class="col-md-12 d-flex justify-content-start">{{item?.departureTerminal?("Terminal&nbsp;&nbsp;&nbsp;"+item?.departureTerminal):''}}</div>
                                </div>
                                
                                <div class="col-md-2 flight-number d-flex align-items-center justify-content-center ">
                                    <mat-icon class="mt-2">flight_takeoff</mat-icon>
                                </div>
                        
                                <div class="col-md-5 ">
                                    <div class="col-md-12  d-flex justify-content-end" style="font-size: 20px;">{{item?.scheduleArrivalDay}}</div>
                                    <div class="col-md-12 bold d-flex justify-content-end">{{item?.arrivalCity}}</div>
                                    <div class="col-md-12 d-flex justify-content-end">{{ item?.scheduleArrivalTime}}</div>
                                    <div class="col-md-12 d-flex justify-content-end " style="font-size: 18px;">{{item?.arrivalAirPort}}</div>
                                    <div class="col-md-12 d-flex justify-content-end">{{item?.arrivalTerminal?("Terminal&nbsp;&nbsp;&nbsp;"+item?.arrivalTerminal):''}}</div>
                                </div>
                            </div>                    
                            </div>
                        </div>
                        </div>
                        <div class="col-md-12 mt-2" style=" border-top:1px solid grey;"></div>
                        </div>
                    </div>
                    <div class="ticket-itinerary-details" >   
                        <div class="col-md-12 row"> 
                            <div class="col-md-3 bold">Fare&nbsp;&nbsp;Basis&nbsp;&nbsp;: {{itinerary?.fareBasis}} </div> 
                            <div class="col-md-3 bold">GDS&nbsp;&nbsp;PNR&nbsp;&nbsp;: {{itinerary?.gdsPnr ? itinerary?.gdsPnr:itinerary?.itineraryPNR}}</div> 
                            <div class="col-md-3 bold">Deal&nbsp;&nbsp;Code&nbsp;&nbsp;: {{itinerary?.dealCode ? itinerary?.dealCode:'NA'}}</div> 
                            <div class="col-md-3 bold">Tour&nbsp;&nbsp;Code&nbsp;&nbsp;:{{itinerary?.tourCode ? itinerary?.tourCode:'NA'}}</div>   
                        </div>  
                        <div class="col-md-12 mt-2" style=" border-top:1px solid grey;"></div>
                    </div>
                    <div  *ngFor="let item of itinerary.itineraryPassengers; index as i" style="font-size: 24px;">
                        <div class="col-md-12 "> 
                            <div class="col-md-12 row"> 
                                <div class="col-md-6 mt-3"> 
                                    <div class="col-md-12 ">
                                        <div class="col-md-12 d-flex justify-content-start align-items-center">
                                        <mat-icon>people</mat-icon>
                                            <span style="padding-left: 4px;font-size: 24px;font-weight: bold;" >{{item?.title}} {{item?.firstName}} {{item?.lastName}}</span>
                                        </div>
                                        <div class="col-md-12 d-flex justify-content-start " style="padding-left: 28px;"> {{item?.type==='ADT'?('Adult'):""}} {{item?.type==='CNN'?('Child'):""}} {{item?.type==='CHD'?('Child'):""}} {{item?.type==='INF'?('Infent'):""}}</div>
                                    </div>
                            
                                </div>
                                <div class="col-md-6">
                                    <div class="trip-details-container">
                                        <div class="panel mt-3"  >
                                            <div class="col-md-12 row" style="font-size: 24px;"> 
                                    
                                                <div class="col-md-4 ">
                                                    <!-- <div class="col-md-12 bold d-flex justify-content-start" >{{item?.ticket ? item?.ticket: item?.pnr}}</div> -->
                                                    <div class="col-md-12 bold d-flex justify-content-start" >                                                    
                                                        {{item?.ticket==='0'?('N/A'):item?.ticket===0?('N/A'):item?.ticket===null?('N/A'):item?.ticket}}
                                                    </div>

                                                    <div class="col-md-12  d-flex justify-content-start">Ticket No.</div>
                                                    <div class="col-md-12  d-flex justify-content-start bold">{{item?.mobile? item?.mobile:'NA' }}</div>
                                                    <div class="col-md-12  d-flex justify-content-start ">Mobile</div>
                                                </div>
                                                <div class="col-md-4  flight-number ">                   
                                                    <div class="col-md-12 text-success bold d-flex justify-content-center bold">{{pnrData?.status ?  statuValue(pnrData?.status):'NA'}}</div>
                                                    <div class="col-md-12 d-flex justify-content-center ">Status</div>
                                                    <div class="col-md-12 d-flex justify-content-center bold">{{item?.empId? item?.empId:'NA'}}</div>
                                                    <div class="col-md-12  d-flex justify-content-center ">EmpId</div>
                                                </div>
                                    
                                                <div class="col-md-4   ">
                                                    <div class="col-md-12  d-flex justify-content-center bold" >{{formatTotalPrice(item?.totalPrice)}}</div>
                                                    <div class="col-md-12 d-flex justify-content-center " >Price</div>
                                                    <div class="col-md-12  d-flex justify-content-center bold" >{{item?.freqFlyerNumber?item?.freqFlyerNumber:'NA'}}</div>
                                                    <div class="col-md-12 d-flex justify-content-center" style="font-size: 24px;">Freq&nbsp;Flyer&nbsp;No.</div>
                                                </div>
                                            </div>   
                                        </div>
                                    </div>   
                                </div>
                            </div>
                            <div class="col-md-12 row"> 
                                <div class="col-md-6 d-flex justify-content-start">
                                    <img [src]="generateQRCodes(item,i,itinerary?.sourceCode,itinerary?.destinationCode,itinerary?.invoiceFlightDetails[0].carrierName,itinerary?.invoiceFlightDetails[0].flightNumber)" alt="QR Code" width="600px"/>
                                </div>
                                <div class="col-md-6 row d-flex justify-content-start">
                                    <span class="col-md-12 mt-3 d-flex justify-content-start bold" >{{item?.email?item?.email:'NA' }}</span>
                                    <span class="col-md-12  d-flex justify-content-start ">Email</span>
                                </div>
                            </div>
                    
                            <div class="col-md-12 mt-2" style=" border-top:1px solid grey;"></div>
                            <div class="col-md-12" >
                                    <div class="col-md-12 row mt-3 pt-2 "> 
                                        <div class="col-md-2">Seat&nbsp;&nbsp;: {{item?.seatMeal[0]?.seatNumber ? item?.seatMeal[0]?.seatNumber : 'NA'}} </div> 
                                        <div class="col-md-2">Meal&nbsp;&nbsp;: {{item?.seatMeal[0]?.mealPreferences ? item?.seatMeal[0]?.mealPreferences : 'NA'}}</div> 
                                        <div class="col-md-8">Baggage&nbsp;&nbsp;:  &nbsp;<strong>Cabin - </strong>{{item?.cabinBaggage ? item?.cabinBaggage:'NA'}}  &nbsp;<strong>Checkin - </strong>{{item?.checkInBaggage ? item?.checkInBaggage:'NA'}} &nbsp;<strong>Extra - </strong>{{item?.extraBaggage ? item?.extraBaggage:'NA' }} </div>   
                                    </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-md-11 mt-5"><h4>GST&nbsp;&nbsp;Details</h4></div>
    <div class="col-md-11   d-flex justify-content-center rounded pt-2 pb-2 mb-1" style="font-size: 24px; border: 1px solid grey;">
        <div class="col-md-4 border-right "  >
            <div class="col-md-12 bold d-flex justify-content-center"> {{pnrData?.gstNumber? pnrData?.gstNumber : 'NA'}} </div>
             <div class="col-md-12 d-flex justify-content-center" >GST&nbsp;&nbsp;Number </div>

        </div>
        <div class="col-md-4">
            <div class="col-md-12 bold d-flex justify-content-center">{{pnrData?.gstName?pnrData?.gstName:'NA'}}</div>
            <div class="col-md-12 d-flex justify-content-center"> GST&nbsp;&nbsp;Name</div>

         </div>
         <div class="col-md-4">
            <div class="col-md-12 bold d-flex justify-content-center">{{pnrData?.gstEmail ? pnrData?.gstEmail : 'NA'}}</div>
            <div class="col-md-12 d-flex justify-content-center">GST&nbsp;&nbsp;Email</div>

         </div>
     </div>

     <div class="col-md-11 mt-5"><h4>Pricing Details</h4></div>
     <div class="col-md-11 row rounded pt-2 pb-2 mb-1" style="font-size: 24px; border: 1px solid grey;" >
            <div class="d-flex justify-content-center"  >
                <div class="col-md-6  pr-0 mr-0" >
                    <div class="col-md-12 row ">
                    <span class="col-md-6 pt-1 pb-1 d-flex justify-content-end" > Mode&nbsp;&nbsp;of&nbsp;&nbsp;Payment&nbsp;&nbsp;: </span>
                    <span class="col-md-6 pt-1 pb-1 d-flex bold justify-content-start"  > {{pnrData?.priceData?.modeOfPayment ? pnrData?.priceData?.modeOfPayment:'Cash'}}</span> 
                    </div>
                </div>
                <div class="col-md-6  pr-0 mr-0"  >
                    <div class="col-md-12 row">
                    <span class="col-md-8 pt-1 pb-1 bold d-flex justify-content-end">Bill&nbsp;&nbsp;To&nbsp;&nbsp;Company</span>
                    <span class="col-md-4 pt-1 pb-1 d-flex justify-content-end" > {{' '}}</span>
                     </div>
                </div>
            </div>

            <div class="d-flex justify-content-center" style="font-size: 24px; border-top:1px solid grey;" >
            <div class="col-md-6 pr-0 mr-0" style="border-right:1px solid grey;" >
                <div class="col-md-12 row">
                <span class="col-md-6 pt-1 pb-1 d-flex justify-content-end" >Base&nbsp;&nbsp;Price&nbsp;&nbsp;:</span>
                <span class="col-md-6 pt-1 pb-1 bold d-flex justify-content-center"  >{{pnrData?.priceData?.totalBaseAmount}} </span>
                </div>
            
                <div class="col-md-12 row">
                <span class="col-md-6 pt-1 pb-1  d-flex justify-content-end" > Airline&nbsp;&nbsp;Taxes&nbsp;&nbsp;and&nbsp;&nbsp;Fees&nbsp;&nbsp;:</span>
                <span class="col-md-6 pt-1 pb-1 bold d-flex justify-content-center" >{{pnrData?.priceData?.airlineTaxes }} </span>
                </div>

                <div class="col-md-12 row">
                <span class="col-md-6 pt-1 pb-1  d-flex justify-content-end" > Airline&nbsp;&nbsp;GST&nbsp;&nbsp;Details&nbsp;&nbsp;:</span>
                <span class="col-md-6 pt-1 pb-1 bold d-flex justify-content-center" >{{pnrData?.airLineGST ? pnrData?.airLineGST:'NA' }} </span>
                </div>

            </div>
            <div class="col-md-6  pr-0 mr-0"  >

                <div class="col-md-12 row">
                <span class="col-md-8 pt-1 pb-1  d-flex justify-content-end">Meal&nbsp;/&nbsp;Seat&nbsp;/&nbsp;Baggage&nbsp;/&nbsp;Misc Charges</span>
                <span class="col-md-4 pt-1 pb-1 bold d-flex justify-content-center" >{{'0'}} </span>
                </div>

                <div class="col-md-12 row">
                <span class="col-md-8 pt-1 pb-1  d-flex justify-content-end"> Finance&nbsp;&nbsp;Charges&nbsp;&nbsp;&nbsp;(s)</span>
                <span class="col-md-4 pt-1 pb-1 bold d-flex justify-content-center" >{{'0'}} </span>
                </div>

                <div class="col-md-12 row">
                <span class="col-md-8 pt-1 pb-1  d-flex justify-content-end"> Management&nbsp;&nbsp;&nbsp;Fee</span>
                <span class="col-md-4 pt-1 pb-1 bold d-flex justify-content-center" >{{pnrData?.priceData?.commissionData?.Fee?.value}} </span>
                </div>

                <div class="col-md-12 row">
                <span class="col-md-8 pt-1 pb-1 d-flex justify-content-end"> GST&nbsp;&nbsp;on&nbsp;&nbsp;Mgmt.&nbsp;&nbsp;Fee&nbsp;&nbsp;&&nbsp;&nbsp;Fin.&nbsp;&nbsp;Charges</span>
                <span class="col-md-4 pt-1 pb-1 bold d-flex justify-content-center" >{{calcMgmtFeeTax(pnrData?.priceData?.commissionData?.Fee)}} </span>
               </div>
            </div>
        </div>
        <div class=" d-flex justify-content-center pt-1 pb-1 " style="font-size: 24px; border-top:1px solid grey;" >
            <div class="col-md-6  ">
                <div class="col-md-12 row">
                <span class="col-md-8 bold d-flex justify-content-center"> Total&nbsp;&nbsp;Fare</span>
                <span class="col-md-4 bold d-flex justify-content-end" >{{pnrData?.priceData?.bookingAmount}} </span>
                </div>
            </div>
            <div class="col-md-6" >
                <div class="col-md-12 row">
                <span class="col-md-8 bold d-flex justify-content-center">Add-ons&nbsp;&nbsp;and&nbsp;&nbsp;Service&nbsp;&nbsp;Fee</span>
                <span class="col-md-4 bold d-flex justify-content-end">{{pnrData?.priceData?.miscPriceData?.Fee?.totalValue}}</span>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center pt-1 pb-1" style="border-top:1px solid grey;" >
            <div class="col-md-6 row"  >
                <span class="col-md-12 bold d-flex justify-content-start"> <span style="color: rgb(0, 98, 255);">Total Price </span>&nbsp;(Total&nbsp;&nbsp;Fare + Add-ons&nbsp;&nbsp;and&nbsp;&nbsp;Service&nbsp;&nbsp;Fee)</span>
            </div>
            <div class="col-md-6 row"  >
                <!-- <span class="col-md-12 bold text-primary d-flex justify-content-end">{{calcFinalAmt(pnrData?.priceData?.totalBookingAmount,pnrData?.priceData?.commissionData)}}</span> -->
                <span class="col-md-12 bold text-primary d-flex justify-content-end">{{pnrData?.priceData?.totalBookingAmount}}</span>

            </div>
        </div>
    </div>            
</div>
